import { HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { Schema } from "effect";
import { Authn } from "../authn";
// Error report schema
const ErrorReport = Schema.Struct({
    // Error details
    name: Schema.String,
    message: Schema.String,
    stack: Schema.optional(Schema.String),
    // Context information
    userId: Schema.optional(Schema.String),
    userEmail: Schema.optional(Schema.String),
    organizationId: Schema.optional(Schema.Number),
    organizationName: Schema.optional(Schema.String),
    // Page/Location info
    url: Schema.String,
    pathname: Schema.String,
    userAgent: Schema.optional(Schema.String),
    // Additional metadata
    timestamp: Schema.String,
    environment: Schema.optional(Schema.String),
    additionalContext: Schema.optional(Schema.Record({
        key: Schema.String,
        value: Schema.Unknown
    }))
});
const ErrorReportResponse = Schema.Struct({
    success: Schema.Boolean,
    message: Schema.optional(Schema.String)
});
export default HttpApiGroup.make("opsv1").annotate(OpenApi.Title, "Ops V1").annotate(OpenApi.Description, "Operational endpoints for monitoring and error reporting").add(HttpApiEndpoint.post("reportError", "/error").setPayload(ErrorReport).addSuccess(ErrorReportResponse).middleware(Authn).annotateContext(OpenApi.annotations({
    summary: "Report Frontend Error (Authenticated)",
    description: "Reports frontend errors to monitoring systems including Slack notifications. Requires authentication."
}))).add(HttpApiEndpoint.post("reportErrorUnauthenticated", "/error/unauthenticated").setPayload(ErrorReport).addSuccess(ErrorReportResponse).annotateContext(OpenApi.annotations({
    summary: "Report Frontend Error (Unauthenticated)",
    description: "Reports frontend errors to monitoring systems including Slack notifications. Does not require authentication."
}))).prefix("/v1/ops");
